

<section>
    <div class="gd__container gd--ccgap">
      <div *ngIf="vmReady; else notReady" class="gd__container">
        <div class="mcbx inleiding">
          <h1 class="mcbx__title" [innerHTML]="pageTitle"></h1>
          <div class="richtext" [innerHTML]="pageContent"></div>
        </div>
      </div>

      <div *ngIf="vmReady" class="gd__container">
        <div class="mcbx">
          <h2 class="mcbx__title" [innerHTML]="modulesTitle"></h2>
        </div>
        <div *ngIf="modules" class="gd__container gd--13">
          <div *ngFor="let module of modules" class="cc__module">
            <h3 class="ccm__title" [innerHTML]="module.name"></h3>
            <div class="cct__badge">
              <img src="{{module.badgeUrl}}" alt="{{module.badgeAlt}}" width="88" height="132">
            </div>
            <div class="ccm__actions">
              <button *ngIf="module.name" 
                (click)="goToModule(module.key)" 
                [class]="module.status ? 'button button--text right-icon' : 'button'"
                id="ipoclick-btn-{{paza}}-{{pagename}}-{{module.meetid}}_{{module.key}}"
                [attr.aria-label]="module.status ? bekijkAria + ' ' + module.name : startAria + ' ' + module.name" 
                [innerHTML]="module.status ? bekijkText : startText"></button>
            </div>
          </div>
        </div>
      </div>
  </div>
</section>

<ng-template #notReady>
  <section>
    <div class="gd__container">
      De veiligheidsmeter wordt geladen...
    </div>
  </section>
</ng-template>